(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ExportPraxedoDialogController', ExportPraxedoDialogController);

    ExportPraxedoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExportPraxedo'];

    function ExportPraxedoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ExportPraxedo) {
        var vm = this;

        vm.exportPraxedo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.exportPraxedo.id !== null) {
                ExportPraxedo.update(vm.exportPraxedo, onSaveSuccess, onSaveError);
            } else {
                ExportPraxedo.save(vm.exportPraxedo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:exportPraxedoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
